import axios from 'axios'

export default {
  getCarWashDisputesForPlace: async ({ commit, rootState, state }, placeId) => {
    commit(
      'app/setLoading',
      { type: 'getCarWashDisputesForPlace', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/disputes/place/${placeId}?page=${state.currentPageNumber}&page_size=${state.pageSize}`,
          config
        )
        .then(response => {
          const nextAvailablePage = parseInt(
            response.headers['x-next-page'],
            10
          )
          commit('setCarWashDisputes', response.data)
          commit('setNextAvailablePage', nextAvailablePage)
          commit(
            'app/setLoading',
            { type: 'getCarWashDisputesForPlace', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getCarWashDisputesForPlace', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  getAllDisputes: async ({ commit, rootState, state }) => {
    commit(
      'app/setLoading',
      { type: 'getAllDisputes', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/disputes?page=${state.currentPageNumber}&page_size=${state.pageSize}`,
          config
        )
        .then(response => {
          const nextAvailablePage = parseInt(
            response.headers['x-next-page'],
            10
          )
          commit('setDisputes', response.data)
          commit('setNextAvailablePage', nextAvailablePage)
          commit(
            'app/setLoading',
            { type: 'getAllDisputes', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getAllDisputes', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  putDispute: async ({ commit, rootState }, payload) => {
    commit(
      'app/setLoading',
      { type: 'putDispute', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .put(
          `${process.env.VUE_APP_URL}/adminapi/disputes/${payload.ID}`,
          { Status: payload.newStatus },
          config
        )
        .then(response => {
          commit('setDisputeInDisputesArray', response.data)
          commit(
            'app/setLoading',
            { type: 'putDispute', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'putDispute', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  postDisputeApprove: async ({ commit, rootState }, disputeUUID) => {
    commit(
      'app/setLoading',
      { type: 'postDisputeApprove', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/disputes/approve?uuid=${disputeUUID}`,
          null,
          config
        )
        .then(response => {
          commit('setDisputeInDisputesArray', response.data)
          commit(
            'app/setLoading',
            { type: 'postDisputeApprove', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'postDisputeApprove', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  postDisputeReject: async ({ commit, rootState }, payload) => {
    commit(
      'app/setLoading',
      { type: 'postDisputeReject', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/disputes/reject?uuid=${payload.disputeUUID}`,
          { comments: payload.comments },
          config
        )
        .then(response => {
          commit('setDisputeInDisputesArray', response.data)
          commit(
            'app/setLoading',
            { type: 'postDisputeReject', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'postDisputeReject', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  }
}
